/** Announcements (/w/:ws/announcements), engage group. Industry-neutral chrome; audience labels come from tenant data. */
export const announcements = {
  title: "Announcements",
  subtitle: "Push urgent news to your app, pin it in the chat widget, and teach the assistant so it can answer follow-up questions.",
  newAnnouncement: "New announcement",
  stats: {
    reachable: "App installs reachable",
    reachableNone: "No app installs registered yet",
    sentThisMonth: "Sent this month",
    pipeline: "{{scheduled}} scheduled · {{drafts}} draft",
    avgOpenRate: "Avg open rate",
    openRateHint: "across sent announcements",
    followUps: "Follow-up questions answered",
    followUpsHint: "by the assistant, from announcements",
  },
  views: {
    label: "Filter announcements",
    all: "All",
    sent: "Sent",
    scheduled: "Scheduled",
    draft: "Drafts",
    archived: "Archived",
  },
  search: "Search announcements…",
  status: {
    sent: "Sent",
    sending: "Sending…",
    scheduled: "Scheduled · {{when}}",
    draft: "Draft",
    archived: "Archived",
  },
  urgent: "Urgent",
  byline: "{{when}} by {{name}}",
  bylineNoName: "{{when}}",
  createdBy: "by {{name}}",
  lastEdited: "Last edited {{when}}",
  lastEditedBy: "Last edited {{when}} by {{name}}",
  audienceSeparator: " · ",
  channels: {
    push: "Mobile push",
    webapp_banner: "Web app banner",
    widget_pin: "Widget pinned",
    email: "Email",
  },
  taught: "Taught to assistant",
  taughtExpires: "Taught to assistant · expires {{date}}",
  teachesOnSend: "Teaches the assistant on send",
  notTaught: "Not yet taught to assistant",
  delivered: "Delivered",
  opened: "Opened",
  aiAnswers: "AI answers",
  openBar: "{{rate}} opened of {{delivered}} delivered",
  estimatedReach: "Estimated reach",
  devices_one: "{{count}} device",
  devices_other: "{{count}} devices",
  sendsIn: "Sends in",
  days_one: "{{count}} day",
  days_other: "{{count}} days",
  hours_one: "{{count}} hour",
  hours_other: "{{count}} hours",
  actions: {
    sendNow: "Send now",
    duplicate: "Duplicate",
    edit: "Edit",
    continueEditing: "Continue editing",
    archive: "Archive",
    restore: "Restore",
    delete: "Delete",
  },
  toasts: {
    sentNow: "Sent now",
    duplicated: "Duplicated as draft",
    archived: "Archived · removed from widget and assistant knowledge",
    restored: "Restored",
    deleted: "Draft deleted",
    draftSaved: "Draft saved",
    scheduled: "Announcement scheduled",
    scheduledTeach: "Announcement scheduled · assistant will learn it on send",
    sent: "Announcement sent",
    sentTeach: "Announcement sent · assistant updated",
    failed: "That didn't work. Please try again.",
  },
  emptyTitle: "No announcements here",
  emptyBody: "Share news with your audience in the app, web app, widget and email.",
  emptySearchBody: "Try another search or filter.",
  loadError: "Announcements couldn't load.",
  statsError: "Announcement stats couldn't load.",
  composer: {
    newTitle: "New announcement",
    editTitle: "Edit announcement",
    titleLabel: "Title",
    titlePlaceholder: "e.g. Office closed tomorrow due to Typhoon Ofel",
    titleRequired: "Add a title",
    messageLabel: "Message",
    messageCounter: "{{count}} / {{max}} · push shows first {{push}}",
    messagePlaceholder: "Write it like a text message — short, specific, with dates and what to do.",
    messageRequired: "Add a message",
    urgent: "Mark as urgent",
    audience: "Audience",
    audienceRequired: "Pick at least one audience",
    segments: "Segments",
    segmentsHint: "Optional. Narrow the audience to segments you define (e.g. a group, branch or level).",
    addSegment: "Add segment",
    segmentPlaceholder: "New segment",
    channels: "Channels",
    channelHints: {
      push: "Your app on iOS & Android",
      webapp_banner: "Top of your web app",
      widget_pin: "Shown when the chat opens on your website",
      email: "To registered email addresses",
    },
    when: "When to send",
    sendNow: "Send now",
    schedule: "Schedule",
    date: "Date",
    time: "Time",
    timeZoneHint: "Time zone: {{zone}}",
    scheduleInvalid: "Pick a send time in the future",
    teachTitle: "Also teach the assistant this info",
    teachLabel: "Teach the assistant",
    teachHelp: "The announcement is added to the Knowledge Base as a temporary source. When someone asks a follow-up question, the assistant answers from this announcement and cites it, instead of saying it doesn't know.",
    forgetAfter: "Forget after",
    expiry: {
      "2d": "2 days",
      "1w": "1 week",
      endOfMonth: "End of month",
      never: "Never",
    },
    agents: "Agents",
    pushPreview: "Push preview",
    pinPreview: "Widget pinned message",
    previewNow: "now",
    previewGreeting: "Hi! How can I help?",
    reach: "Estimated reach: {{devices}} · {{emails}}",
    reachPending: "Estimating reach…",
    emails_one: "{{count}} email",
    emails_other: "{{count}} emails",
    saveDraft: "Save draft",
    send: "Send announcement",
    scheduleSubmit: "Schedule announcement",
    noSendPermission: "You can save drafts. Sending needs the announcements send permission.",
  },
};
